const pt_br = {
  state: {
    expression_1: 'Avatar',
    expression_2: 'Campanha',
    expression_3: 'Campanhas',
    expression_4: 'Canal',
    expression_5: 'Canais',
    expression_6: 'Escolha um canal',
    expression_7: 'Escolha um canal...',
    expression_8: 'Escolha um canal para visualizar o gráfico.',
    expression_9: 'Selecione uma opção...',
    expression_10: 'Limpar notificações',
    expression_11: 'Indicadores',
    expression_12: 'Equipe',
    expression_13: 'Equipes',
    expression_14: 'Baixar gráfico',
    expression_15: 'Tempo',
    expression_16: 'Engajamento',
    expression_17: 'Encerrado por',
    expression_18: 'Encerrado em',
    expression_19: 'Encerrados (hoje)',
    expression_20: 'Protocolos finalizados hoje',
    expression_21: 'Encerrados',
    expression_22: 'Encerrados essa semana',
    expression_23: 'Funil',
    expression_24: 'opcional',
    expression_25: 'Funis',
    expression_26: 'As regras de negócio abaixo estão disponíveis apenas para clientes dos planos BEECRM. Entre em contato com nossa equipe de comercial e contrate agora mesmo!',
    expression_27: 'Saiba como ativar',
    expression_28: 'id',
    expression_29: 'Atendendo',
    expression_30: 'Protocolos em atendimento',
    expression_31: 'Interesse',
    expression_32: 'Interesses',
    expression_33: 'Últimas conversas',
    expression_34: 'Contato',
    expression_35: 'Contatos',
    expression_36: 'Carregando...',
    expression_37: 'Sair',
    expression_38: 'Chat',
    expression_39: 'Negociações perdidas esse mês',
    expression_40: 'Meu perfil',
    expression_41: 'Perfil',
    expression_42: 'Nome',
    expression_43: 'Nenhuma meta existente.',
    expression_44: 'Nenhum protocolo foi encontrado.',
    expression_45: 'Notificação',
    expression_46: 'Notificações',
    expression_47: 'Qualificações',
    expression_48: 'Agente',
    expression_49: 'Agentes',
    expression_50: 'Operadores',
    expression_51: 'Operadores',
    expression_52: 'Dashboard',
    expression_53: 'Performance',
    expression_54: 'Contato',
    expression_55: 'Protocolo',
    expression_56: 'Qualificação',
    expression_57: 'Qualificações',
    expression_58: 'Relatório',
    expression_59: 'Relatórios',
    expression_60: 'Pesquisar',
    expression_61: 'segundos',
    expression_62: 'Configurações',
    expression_63: 'Ver mais',
    expression_64: 'Ir para Relatórios',
    expression_65: 'Sobrenome',
    expression_66: 'Início sessão',
    expression_67: 'Status',
    expression_68: 'Tarefa',
    expression_69: 'Tarefas',
    expression_70: 'É Português!',
    expression_71: 'esse mês',
    expression_72: 'Protocolo',
    expression_73: 'Conversas',
    expression_74: 'Conectar ao WhatsApp API Oficial',
    expression_75: 'TMA',
    expression_76: 'Tempo médio de atendimento',
    expression_77: 'TMB',
    expression_78: 'Tempo médio no chat-bot',
    expression_79: 'TME',
    expression_80: 'Tempo médio de espera',
    expression_81: 'Agente',
    expression_82: 'Usuários',
    expression_83: 'Aguardando',
    expression_84: 'Protocolos aguardando atendimento',
    expression_85: 'Organização',
    expression_86: 'Negociações ganhas esse mês',
    expression_87: 'Em negociação',
    expression_88: 'Ganho',
    expression_89: 'Perdido',
    expression_90: 'Média',
    expression_91: 'Os resultados da sua pesquisa serão exibidos abaixo',
    expression_92: 'Informações do contato',
    expression_93: 'Detalhes',
    expression_94: 'Gerencie os usuários do sistema',
    expression_95: 'Detalhes do usuário',
    expression_96: 'Edite as configurações do usuário',
    expression_97: 'Cadastre e gerencie seus canais de comunicação',
    expression_98: 'Edite as configurações do seu canal',
    expression_99: 'Campanhas de Marketing',
    expression_100: 'Criar campanha',
    expression_101: 'Edite as configurações da publicação',
    expression_102: 'Endereços',
    expression_103: 'Relatório de Engajamento',
    expression_104: 'URL\'s',
    expression_105: 'Relatório de Performance',
    expression_106: 'Relatório de Conversas',
    expression_107: 'Comece a cadastrar ou administrar suas tarefas',
    expression_108: 'Exibe o Nome do Atendente nas mensagens que foram enviadas',
    expression_109: 'Importar contatos',
    expression_110: 'Inserir contato',
    expression_111: 'Identifica Agente',
    expression_112: 'Exportar contatos',
    expression_113: 'Voltar',
    expression_114: 'Pesquisar usuário',
    expression_115: 'Cadastrar usuário',
    expression_116: 'registros encontrados',
    expression_117: 'registro encontrado',
    expression_118: 'Cadastrar canal',
    expression_119: 'Pesquisar canal',
    expression_120: 'Salvar',
    expression_121: 'Limite de 31 dias',
    expression_122: 'Exportar Excel',
    expression_123: 'Todos os canais',
    expression_124: 'Escolha um departamento...',
    expression_125: 'Escolha um departamento',
    expression_126: 'Escolha um atendente',
    expression_127: 'Todos os atendentes',
    expression_128: 'Pesquisar leads',
    expression_129: 'Pesquisar Conversas',
    expression_130: 'Exportar PDF',
    expression_131: 'Para exibir os registros, faça uma pesquisa',
    expression_132: 'Atualizado em',
    expression_133: 'Para exibir os resultados, selecione um canal',
    expression_134: 'Ajuda',
    expression_135: 'Adicionar nova tarefa',
    expression_136: 'Contatos',
    expression_137: 'Verificados',
    expression_138: 'Verificado',
    expression_139: 'Não possuem conta',
    expression_140: 'Não possui conta',
    expression_141: 'Não Verificados',
    expression_142: 'Não Verificado',
    expression_143: 'Nenhum e-mail cadastrado',
    expression_144: 'Data de descadastro',
    expression_145: 'Avaliação',
    expression_146: 'Nenhuma tag foi vinculada.',
    expression_147: 'Arraste as opções ao lado',
    expression_148: 'Nenhum contato foi encontrado',
    expression_149: 'Notas',
    expression_150: 'Tags',
    expression_151: 'Tag',
    expression_152: 'Carteira',
    expression_153: 'Carteiras',
    expression_154: 'Sexo feminino',
    expression_155: 'Sexo masculino',
    expression_156: 'Data da inscrição',
    expression_157: 'Iniciar Conversa',
    expression_158: 'Negociação',
    expression_159: 'Data de inscrição',
    expression_160: 'Newsletter',
    expression_161: 'E-mail',
    expression_162: 'E-mail não cadastrado',
    expression_163: 'Descadastrado em ',
    expression_164: 'Inscrição em ',
    expression_165: 'Avaliação (NPS)',
    expression_166: 'Informações',
    expression_167: 'Editar',
    expression_168: 'Documento',
    expression_169: 'Não cadastrado',
    expression_170: 'Não informado',
    expression_171: 'Não cadastrada',
    expression_172: 'Não informada',
    expression_173: 'Perfil de Negócios',
    expression_174: 'Cargo',
    expression_175: 'Nome da Rua',
    expression_176: 'CEP',
    expression_177: 'Cidade',
    expression_178: 'Número',
    expression_179: 'Bairro',
    expression_180: 'Estado',
    expression_181: 'Ponto de referência',
    expression_182: 'País',
    expression_183: 'Tipo de nota',
    expression_184: 'Crie uma anotação',
    expression_185: 'Escreva algo...',
    expression_186: 'Nenhuma anotação foi criada.',
    expression_187: 'Tags disponíveis',
    expression_188: 'Clique no nome da tag para vincular',
    expression_189: 'Nenhuma tag vinculada.',
    expression_190: 'Baixar arquivo',
    expression_191: 'Operador',
    expression_192: 'NPS',
    expression_193: 'N° do Protocolo',
    expression_194: 'Vendido!',
    expression_195: 'Não vendido',
    expression_196: 'Nenhum protocolo foi registrado.',
    expression_197: 'Vincular atendente',
    expression_198: 'Ação',
    expression_199: 'Transferir contato',
    expression_200: 'Remover',
    expression_201: 'Nenhum atendente vinculado à esse lead.',
    expression_202: 'Escolha um canal e um departamento para visualizar os quadros.',
    expression_203: 'Documentos',
    expression_204: 'Você já atingiu o limite de usuários nesse canal!',
    expression_205: 'Em Andamento',
    expression_206: 'Encerradas',
    expression_207: 'Gere um QRCode',
    expression_208: 'Olá :operator_name, você está ai ?',
    expression_209: 'Caso não confirme, você será desconectado em 5 minutos!',
    expression_210: 'Sim, estou aqui!',
    expression_211: 'Ao clicar em Continuar, você concorda com os',
    expression_212: 'Termos da Meta para o Whatsapp Business',
    expression_213: 'Erro ao verificar número',
    expression_214: 'Favor entrar em contato com o suporte e informar o <strong>Código de erro: 1001</strong>',
    expression_215: 'total',
    expression_216: 'enviados',
    expression_217: 'Telefone não possui Whatsapp',
    expression_218: 'Não é possível adicionar ou abrir um ticket com este telefone, pois ele não possui conta no Whatsapp',
    expression_219: 'Mensagens Enviadas',
    expression_220: 'Mensagens Recebidas',
    expression_221: 'Inbox',
    expression_222: 'Senha',
    expression_223: 'Mostrar senha',
    expression_224: 'Esconder senha',
    expression_225: 'Criar nova senha',
    expression_226: 'Esqueci a senha',
    expression_227: 'Entrar',
    expression_228: 'E-mail verificado com sucesso!',
    expression_229: 'Ir para o dashboard',
    expression_230: 'Link inválido!',
    expression_231: 'Parece que o link que você está tentando acessar já não está mais disponível.',
    expression_232: 'Voltar ao inicio',
    expression_233: 'Busque por um nome ou telefone.',
    expression_234: 'Indisponível',
    expression_235: 'Visto por último',
    expression_236: 'Canal Bloqueado',
    expression_237: 'Canal Online',
    expression_238: 'Canal Offline',
    expression_239: 'Nenhum canal foi cadastrado até o momento.',
    expression_240: 'Salvar alterações',
    expression_241: 'Parâmetros',
    expression_242: 'Horário de atendimento',
    expression_243: 'Qualificação do Protocolo',
    expression_244: 'Respostas Rápidas',
    expression_245: 'A campanha voltará a ser enviada para seus contatos.',
    expression_246: 'Auto atendimento',
    expression_247: 'Ativação',
    expression_248: 'Integrações',
    expression_249: 'Widget para Site',
    expression_250: 'Templates HSM',
    expression_251: 'Planos e adicionais',
    expression_252: 'Você atingiu o limite de alguns recursos.',
    expression_253: 'Total de campanhas',
    expression_254: 'Campanhas concluídas',
    expression_255: 'Campanhas agendadas',
    expression_256: 'Campanhas em andamento',
    expression_257: 'Tipo da campanha',
    expression_258: 'Comum',
    expression_259: 'Data de criação',
    expression_260: 'Data do envio',
    expression_261: 'Prévia do texto',
    expression_262: 'Encerrada',
    expression_263: 'Midia',
    expression_264: 'Texto',
    expression_265: 'Métricas de envio',
    expression_266: 'Métricas',
    expression_267: 'lista(s) finalizada(s)',
    expression_268: 'Público alvo',
    expression_269: 'Todos os leads válidos',
    expression_270: 'Nenhuma campanha foi criada até o momento.',
    expression_271: 'Termos e condições',
    expression_272: 'Para prosseguir com a criação da sua campanha, você deve concordar com os termos à seguir:',
    expression_273: 'Para sua segurança, nunca execute duas ou mais campanhas simultâneamente. Isso poderá resultar em banimento permantente do seu número.',
    expression_274: 'Só clique em "Salvar publicação" se tiver certeza que todas as configurações estão corretas.',
    expression_275: 'As mensagens utilizando uma lista de transmissão só serão encaminhadas à usuários que adicionarem seu número de telefone à agenda telefonica deles e já comunicou pelo menos uma vez no WhatsApp dentro do sistema.',
    expression_276: 'Evite ao máximo importar listas de contatos que nunca comunicaram com o sistema e que não tenham seu número salvo na agenda. O WhatsApp valida as listas e pode não enviar caso detecte que seus integrantes nunca se comunicaram ou ainda que não tem o contato salvo. Isso pode impactar aqueles que estão de acordo com as regras.',
    expression_277: 'O horário de envio se torna muito importante para que o lead não rejeite suas transmissões. O horário adequado para o envio de transmissão em massa é entre 08h até 18h.',
    expression_278: 'Observe que a utilização frequente de transmissão em massa pode levar os leads à denunciarem suas mensagens como SPAM.',
    expression_279: 'Aceitar e prosseguir',
    expression_280: 'Publicar em',
    expression_281: 'Selecionar todos',
    expression_282: 'Nenhum canal disponível para campanha.',
    expression_283: 'Tipo de campanha',
    expression_284: 'Campanha do Tipo Lista de Transmissão',
    expression_285: 'Escolha uma opção...',
    expression_286: 'Todos os leads',
    expression_287: 'Enviar para tags',
    expression_288: 'Conteúdo da campanha',
    expression_289: 'Escreva o conteúdo da campanha. Você pode anexar uma mídia ou agendar o envio da publicação.',
    expression_290: "Método de envio",
    expression_291: 'Programe o que será enviado automaticamente quando o lead enviar uma mensagem.',
    expression_292: 'Envio imediato',
    expression_293: 'Envio agendado',
    expression_294: 'Se optar por esta opção a mensagem de apresentação será substituida pela mídia que enviar aqui.',
    expression_295: 'Mensagem de apresentação (boas-vindas)',
    expression_296: 'Adicionar mais um',
    expression_297: 'Remover mídia',
    expression_298: 'Adicionar emoji',
    expression_299: 'As campanhas por Status contendo apenas texto terão cores de fundo aleatórias. As cores mostradas aqui não meramente ilustrativas.',
    expression_300: 'Pré-visualização da mensagem',
    expression_301: 'Sua mensagem aparecerá aqui...',
    expression_302: 'Meu status',
    expression_303: 'Gerar campanha',
    expression_304: 'Indique quais leads devem receber a campanha.',
    expression_305: 'Chamada em andamento...',
    expression_306: 'Chamando...',
    expression_307: 'Encerrar ligação',
    expression_308: 'Tirar do mudo',
    expression_309: 'Deixar mudo',
    expression_310: 'Deseja excluir todas as notificações?',
    expression_311: 'Essa ação é irreversível.',
    expression_312: 'Atendimento',
    expression_313: 'Pausando a campanha você pode retomá-la posteriormente.',
    expression_314: 'Total de Protocolos',
    expression_315: 'Protocolos Aguardando',
    expression_316: 'Protocolos Encerrados',
    expression_317: 'Encerrados',
    expression_318: 'Protocolos Rejeitados',
    expression_319: 'Rejeitados',
    expression_320: 'Métricas diárias (esse mês)',
    expression_321: 'Selecione um canal para visualizar o relatório.',
    expression_322: 'Nenhuma origem foi cadastrada nesse canal.',
    expression_323: 'Total de canais que tiveram leads únicos',
    expression_324: 'Total de departamentos que tiveram leads únicos',
    expression_325: 'Total de atendentes',
    expression_326: 'Total de leads únicos nesse mês',
    expression_327: 'Contatos (esse mês)',
    expression_328: 'Total de leads únicos no último mês',
    expression_329: 'Contatos (mês anterior)',
    expression_330: 'Nome do Canal',
    expression_331: 'Não encontramos nenhum dado referente à esse filtro.',
    expression_332: 'Escolha um canal, um departamento e/ou um atendente para visualizar o relatório detalhado.',
    expression_333: 'Contatos cadastrados(mês)',
    expression_334: 'TOTAL',
    expression_335: 'Nenhum atendimento foi realizado até o momento.',
    expression_336: 'Adicionar submenu',
    expression_337: 'Opção oculta',
    expression_338: 'Opção visível',
    expression_339: 'Excluir opção',
    expression_340: 'Fechar',
    expression_341: 'Opção',
    expression_342: 'Digite o número correspondente à essa opção.',
    expression_343: 'Legenda',
    expression_344: 'Digite o título ou legenda dessa opção.',
    expression_345: 'Palavras Chave',
    expression_346: 'Utilize o campo abaixo para que lead possa identificar o menu com palavras-chave, separe sempre por vírgula.',
    expression_347: 'Ex: "receber ofertas, sim, quero receber"',
    expression_348: 'Mensagem (texto e/ou mídia)',
    expression_349: 'Digite uma mensagem ou anexe uma mídia para ser enviada ao Contato.',
    expression_350: 'Escolha a TAG que o Contato será vinculado automaticamente.',
    expression_351: 'Defina se os Contatos serão automaticamente inscritos na Newsletter.',
    expression_352: 'Nenhuma opção criada.',
    expression_353: 'Deseja mesmo realizar essa ação?',
    expression_354: 'Sim, prosseguir',
    expression_355: 'Cancelar',
    expression_356: 'Configurações da Organização',
    expression_357: 'Clique para bloquear o canal',
    expression_358: 'Bloquear',
    expression_359: 'Clique para desbloquear o canal',
    expression_360: 'Desbloquear',
    expression_361: 'Limpar mensagens',
    expression_362: 'Clique para limpar as mensagens da fila de envios',
    expression_363: 'Departamento',
    expression_364: 'Nome',
    expression_365: 'Complemento / Referência',
    expression_366: 'Regras de Negócio',
    expression_367: 'Atendimento Humano',
    expression_368: 'API',
    expression_369: 'Campanha',
    expression_370: 'Cadastrar contato',
    expression_371: 'Ocultar contato',
    expression_372: 'Mensagem de Transferência',
    expression_373: 'Distribuição Automática',
    expression_374: 'Utilize esse QR Code em suas campanhas de marketing para levar seus visitantes ao aplicativo WhatsApp. O visitante não precisa baixar nenhuma outra aplicação, apenas apontar a câmera do celular para a imagem.',
    expression_375: 'Faça download do seu QR-code do WhatsApp abaixo:',
    expression_376: 'Baixar',
    expression_377: 'Utilize esse QR Code para levar seus visitantes à adicionarem o telefone desse canal nas agendas dos seus celulares. O visitante não precisa baixar nenhuma outra aplicação, apenas apontar a câmera do celular para a imagem.',
    expression_378: 'Faça download do seu QR-code para V-Card abaixo:',
    expression_379: 'Adicionar midia',
    expression_380: 'Variáveis e Formatação',
    expression_381: 'Dicas:',
    expression_382: 'Utilize a variável',
    expression_383: 'para exibir o nome do lead na mensagem. Exiba palavras em negrito utilizando',
    expression_384: 'antes e depois do texto desejado. Por exemplo, digite:',
    expression_385: 'Resultado',
    expression_386: 'Menus do Bot',
    expression_387: 'Configure as opções que serão exibidas ao contato. O lead deverá digitar a opção desejada para ser direcionado à um departamento ou conteúdo que você determinar abaixo.',
    expression_388: 'Adicionar ao menu principal',
    expression_389: 'Suporte',
    expression_390: 'Olá',
    expression_391: 'Eu sou o',
    expression_392: 'a inteligência artifical do',
    expression_393: 'Estou preparado para atender seus clientes, responder perguntas e enviar ofertas, por exemplo.',
    expression_394: 'Configure minhas opções no menu ao lado.',
    expression_395: 'Configure as opções do seu',
    expression_396: 'Adicionar departamento',
    expression_397: 'Limite de registros excedido',
    expression_398: 'Você pode criar departamentos específicos para segmentar seu fluxo de atendimento. Na sequência, estabeleça uma "Escala de Atendimento", onde você definirá os horários de funcionamento. Depois, vincule alguns usuários como atendentes ou configure um "Chat-bot" para começar a movimentar seus chamados.',
    expression_399: 'Clique aqui para saber mais.',
    expression_400: 'Nome do Departamento',
    expression_401: 'Você não pode excluir o departamento padrão',
    expression_402: 'O usuário não está cadastrado como atendente.',
    expression_403: 'Finalizada',
    expression_404: 'Adicionar etapa',
    expression_405: "Você precisa ter pelo menos um 'Interesse', uma 'Qualificação' e uma 'Origem do Protocolo' cadastradas.",
    expression_406: 'Atenção',
    expression_407: 'Gostaria de enviar a mensagem mesmo assim ?',
    expression_408: 'Por favor informe uma data inicial e uma data final para sua pesquisa de campanhas.',
    expression_409: 'Nenhuma etapa cadastrada.',
    expression_410: 'Adicionar template',
    expression_411: 'Nome do modelo',
    expression_412: 'Categoria',
    expression_413: 'Prévia',
    expression_414: 'Idiomas',
    expression_415: 'Aprovado',
    expression_416: 'Reprovado',
    expression_417: 'Enviado',
    expression_418: 'Pendente',
    expression_419: 'Nenhum interesse cadastrado.',
    expression_420: 'Deseja excluir esse template?',
    expression_421: 'Sim, excluir',
    expression_422: 'Comunicações',
    expression_423: 'Você precisa configurar a integração antes de ativá-la.',
    expression_424: 'Configurar',
    expression_425: 'Ativo',
    expression_426: 'Inativo',
    expression_427: 'Você precisa informar um token!',
    expression_428: 'Você não tem permissão para alterar!',
    expression_429: 'Adicionar interesse',
    expression_430: 'Defina aqui os possíveis interesses que poderão trazer seus leads até o atendimento. Os "interesses" podem ser os mais variados, como os produtos ou serviços que a sua empresa oferece. Por exemplo, no caso de uma loja de veículos, poderíamos identificar interesses como: "Carros novos, Carros usados e Autopeças".',
    expression_431: 'Nome do Interesse',
    expression_432: "Você precisa ter pelo menos um 'Interesse' quando o funil estiver habilitado.",
    expression_433: 'Adicionar qualificação',
    expression_434: 'As qualificações ajudam a gerar relatórios e métricas para melhorar a tomada de decisão na sua empresa. Os atendentes podem qualificar os protocolos de acordo com o assunto tratado em cada protocolo criado. Por exemplo: "Dúvida, Sugestão, Engano".',
    expression_435: 'Nome da Qualificação',
    expression_436: "Você precisa ter pelo menos uma 'Qualificação' quando o funil estiver habilitado.",
    expression_437: 'Nenhuma qualificação cadastrada.',
    expression_438: 'Abertura',
    expression_439: 'Encerramento',
    expression_440: 'Segunda-feira',
    expression_441: 'Terça-feira',
    expression_442: 'Quarta-feira',
    expression_443: 'Quinta-feira',
    expression_444: 'Sexta-feira',
    expression_445: 'Sábado',
    expression_446: 'Domingo',
    expression_447: 'Adicionar atendente',
    expression_448: 'Depois de criar departamentos e definir sua escala de atendimento, você poderá vincular seus usuários como atendentes desse canal. Dessa forma, esses usuários terão acesso ao "Chat" em tempo real com os leads, de acordo com o fluxo de atendimento definido por você.',
    expression_449: 'Nome do Operador',
    expression_450: 'Nenhum atendente cadastrado.',
    expression_451: 'Temporização',
    expression_452: 'Tempo Ocioso (Operador)',
    expression_453: 'Defina o tempo máximo que os seus atendentes devem responder um chamado. Um alerta será exibido ao atendente dentro do prazo que você estipular abaixo para que ele dê continuidade ao atendimento em aberto.',
    expression_454: 'minutos',
    expression_455: 'Tempo ocioso Auto atendimento',
    expression_456: 'Estipule o tempo máximo que deseja aguardar por uma resposta do seu lead no CHATBOT.  BOT enviará uma mensagem e encerrará o protocolo automaticamente quando atingir o período que você informar abaixo.',
    expression_457: 'Tempo Ocioso (Contato)',
    expression_458: 'Defina um prazo limite de espara por uma interação do seu lead. Uma mensagem automática será enviada e o protocolo será dado como encerrado automaticamente quando atingir o perído informado abaixo.',
    expression_459: 'Tempo ocioso Protocolo',
    expression_460: 'Defina uma janela de tempo que o sistema irá ignorar novas mensagens do lead após o encerramento de um protocolo. Informe abaixo quanto tempo.',
    expression_461: 'Tempo ocioso Tentativas invalidas',
    expression_462: 'Defina o número máximo de tentativas inválidas que um lead poderá digitar no CHATBOT. Uma mensagem automática será enviada e o protocolo será encerrado quando atingir a quantidade informada abaixo.',
    expression_463: 'vezes',
    expression_464: 'Mensagens de sistema',
    expression_465: 'Programe mensagens automáticas que serão enviadas de acordo com o estágio do atendimento.',
    expression_466: 'Boas-vindas',
    expression_467: 'Esse texto será enviado sempre que seu canal receber a primeira mensagem de um lead.',
    expression_468: "Ex: 'Olá, {{NAME}}! Obrigado por entrar em contato conosco. Já iremos iniciar seu atendimento.'",
    expression_469: 'Encerramento',
    expression_470: 'Mensagem que será enviada sempre que um protocolo for finalizado.',
    expression_471: "Ex: 'Agradecemos seu contato. Até breve!'",
    expression_472: 'Inatividade do Operador',
    expression_473: "Essa mensagem de alerta será exibida para seu atentente, respeitando o prazo que você determinou na temporização de 'Tempo Ocioso (Operador)'",
    expression_474: "Ex: 'Atenção! Você precisa dar continuidade ao chamado ou encerrá-lo.'",
    expression_475: "Essa mensagem será exibida para o seu lead quando ele deixar de interagir com o canal respeitando o prazo que você determinou na temporização de 'Tempo Ocioso (Contato)'",
    expression_476: 'Inatividade do contato',
    expression_477: "Ex: 'Por falta de interação o atendimento foi finalizado. Retorne quando desejar.'",
    expression_478: "Ex: 'Por falta de interação o atendimento foi finalizado. Retorne quando desejar.'",
    expression_479: "Inatividade auto atendimento",
    expression_480: "Essa mensagem será exibida para o seu lead quando ele deixar de interagir com o BOT, respeitando o prazo que você determinou na temporização de 'Tempo Ocioso (Chat-Bot)'",
    expression_481: "Ex: 'Agradecemos o contato e estaremos à disposição.'",
    expression_482: "Horário de Atendimento",
    expression_483: "Essa mensagem será enviada para os leads que interagirem com o canal fora do horário de atendimento informado na 'ESCALA DE ATENDIMENTO' de cada departamento.",
    expression_484: "Caro cliente, já encerramos o atendimento por hoje. Nosso horário de funcionamento é de Segunda à Sexta, das 9h às 18h.",
    expression_485: "Pequisa de Satisfação",
    expression_486: "Essa mensagem será enviada ao lead solicitando que ele responda uma pesquisa de satisfação com relação ao atendimento.",
    expression_487: "Ter você como cliente nos motiva à oferecer sempre os melhores serviços. Clique no link e avalie nosso atendimento.",
    expression_488: "Encerramento Pesquisa",
    expression_489: "Mensagem que será exibida quando o cliente responder a pesquisa de satisfação.",
    expression_490: "Obrigado por responder! Com sua ajuda poderemos melhorar cada vez mais nosso atendimento.",
    expression_491: 'Editar plano',
    expression_492: 'Cancelar edição',
    expression_493: 'Funções',
    expression_494: 'Quantidade',
    expression_495: 'Utilizados',
    expression_496: 'Limite excedido! Caso precise de mais, procure seu consultor e contrate.',
    expression_497: 'Informação atualizada à cada 1 (uma) hora.',
    expression_498: 'Sim',
    expression_499: 'Não',
    expression_500: 'Respostas Rápidas',
    expression_501: 'Adicionar uma resposta',
    expression_502: 'Limite registros excedido',
    expression_503: 'Padronize e automatize o envio de respostas com ajuda desse recurso. Você poderá definir textos específicos para cada departamento e enriquecer as mensagens anexando imagens. Essas respostas serão exibidas para os atendentes no "Chat".',
    expression_504: 'Atalho / Marcação',
    expression_505: 'Mensagem',
    expression_506: 'Imagem',
    expression_507: 'Nenhum resposta cadastrada.',
    expression_508: 'Pausar',
    expression_509: 'Retomar',
    expression_510: 'Todos os tipos',
    expression_511: 'Oportunidades',
    expression_512: "Galeria",
    expression_513: "HSM",
    expression_514: "Adicionar tag",
    expression_515: 'As Tags servem para agrupar diversos leads numa determinada classificação. Com ajuda desse recurso você poderá segmentar suas campanhas de marketing ou obter relatórios mais detalhados. Exemplo: "Prospects, Clientes, Colaboradores", etc.',
    expression_516: "Nome da Tag",
    expression_517: "Nenhuma tag cadastrada.",
    expression_518: "Textos do Widget",
    expression_519: "Use esse espaço para atrair seus visitantes com uma mensagem curta.",
    expression_520: "Título do Widget",
    expression_521: "Mensagem de saudação",
    expression_522: "Mensagem de finalização",
    expression_523: "Personalize o estilo",
    expression_524: "Use esse espaço para atrair seus visitantes com uma mensagem curta.",
    expression_525: "Posição",
    expression_526: "Lado direito",
    expression_527: "Lado esquerdo",
    expression_528: "Cor do botão",
    expression_529: "Remover imagem",
    expression_530: "Anexar arquivo",
    expression_531: "Insira este código no seu site",
    expression_532: "Copie o código abaixo e cole no seu site, dentro da tag",
    expression_533: "Prévia do Widget",
    expression_534: "Envio de SMS",
    expression_535: "Ligação Voip",
    expression_536: "Envio de HSM",
    expression_537: "Início",
    expression_538: "Transferir",
    expression_539: "Continuar protocolo",
    expression_540: "Pausar protocolo",
    expression_541: "Finalizar",
    expression_542: "Outras opções",
    expression_543: "Contato",
    expression_544: "Localização",
    expression_545: "beta",
    expression_546: "Histórico",
    expression_547: "Variáveis",
    expression_548: "info",
    expression_549: "Minimizar",
    expression_550: "Detalhes",
    expression_551: "Nenhuma resposta rápida encontrada.",
    expression_552: "Emojis",
    expression_553: "Anexar arquivo",
    expression_554: "Esse lead não possui uma conta válida no WhatsApp",
    expression_555: "Você não possui uma conversa aberta com esse lead.",
    expression_556: "Digite algo ou / para acessar as respostas rápidas...",
    expression_557: "Gravando áudio...",
    expression_558: "Gravar áudio",
    expression_559: "Enviar mensagem",
    expression_560: "Enviar modelos de mensagem",
    expression_561: "Parar gravação",
    expression_562: "Enviar",
    expression_563: "Excluir gravação",
    expression_564: "Informações do contato",
    expression_565: "Perfil",
    expression_566: "Sexo",
    expression_567: "Indefinido",
    expression_568: "Feminino",
    expression_569: "Masculino",
    expression_570: "Digite sua anotação...",
    expression_571: "Nenhuma anotação.",
    expression_572: "Valor da Negociação",
    expression_573: "Negociação ganha",
    expression_574: "Negociação perdida",
    expression_575: "Descrição",
    expression_576: "Nenhum interesse",
    expression_577: "Nenhuma qualificação",
    expression_578: "Nenhuma origem",
    expression_579: "Pesquisar contato no chat...",
    expression_580: "Pesquisar contato na agenda...",
    expression_581: "Pesquisar na agenda",
    expression_582: "Bem vindo",
    expression_583: "Para iniciar uma nova conversa, clique na aba esquerda.",
    expression_584: "Você precisa confirmar seu endereço de e-mail",
    expression_585: "Reenviar e-mail de confirmação",
    expression_586: "Aguardando",
    expression_587: "Atendendo",
    expression_588: "Atendendo",
    expression_589: "Pausado",
    expression_590: "Pausado",
    expression_591: "Fora de horário",
    expression_592: "Classificação",
    expression_593: "negociações",
    expression_594: "Nenhuma notificação.",
    expression_595: "Tipo do canal",
    expression_596: "Escolha um tipo...",
    expression_597: "Criar canal",
    expression_598: "Escolha um usuário...",
    expression_599: "Cadastrar novo canal",
    expression_600: "Adicionar atentente ao canal",
    expression_601: "Campanha pausada",
    expression_602: "Nome da etapa",
    expression_603: "Data de Início",
    expression_604: "Data de Vencimento",
    expression_605: "Escolha um atendente...",
    expression_606: 'Cadastrar novo contato',
    expression_607: 'Leia as instruções abaixo antes de cadastrar um novo contato! Se você cadastrar números sem seguir esse padrão, poderá ter duplicidade de protocolos e leads dentro do sistema. Essas são regras expressas do aplicativo WhatsApp.',
    expression_608: 'Como cadastrar',
    expression_609: 'Para cadastrar um lead no',
    expression_610: 'use o padrão numérico internacional, incluindo DDI (código do país) e DDD (por exemplo: 5511988776655), sem espaços ou qualquer outros tipos de caracteres. Caso não siga esses padrões não conseguirá contato com o lead.',
    expression_611: 'Nono dígito para WhatsApp',
    expression_612: 'Apenas os números dos Estados do ES, RJ e SP podem receber o nono dígito. Números de outros Estados',
    expression_613: 'devem ser cadastrados usando o nono dígito.',
    expression_614: 'Exemplos',
    expression_615: 'Com o nono dígito',
    expression_616: 'Sem o nono dígito',
    expression_617: 'Este campo é obrigatório',
    expression_618: 'Campos obrigatórios',
    expression_619: 'Esse lead já está cadastrado nesse canal e possui um protocolo aberto.',
    expression_620: 'Esse lead já está cadastrado nesse canal!',
    expression_621: 'Abrir protocolo',
    expression_622: 'Prosseguir',
    expression_623: 'Preencha os campos acima',
    expression_624: 'Esse lead não pertence à você.',
    expression_625: 'Você precisa selecionar um canal e um departamento.',
    expression_626: 'Vincular atentente',
    expression_627: 'Você excedeu seu limite de atendentes cadastrados.',
    expression_628: 'Adicionar resposta rápida',
    expression_629: 'Marcação',
    expression_630: 'As marcações ajudam a organizar suas respostas.',
    expression_631: 'Conteúdo da Mensagem',
    expression_632: 'Clique para anexar um arquivo.',
    expression_633: 'Tipos permitidos: JPG, JPEG ou PNG.',
    expression_634: 'O tamanho máximo por arquivo é de 15MB.',
    expression_635: 'Nome da tarefa',
    expression_636: 'Nome do destinatário',
    expression_637: 'Escolha um destinatário...',
    expression_638: 'Prioridade',
    expression_639: 'Escolha uma prioridade...',
    expression_640: 'Salvar tarefa',
    expression_641: 'Criar template HSM',
    expression_642: 'Os exemplos serão enviados para o Facebook como parte do processo de aprovação de templates. Se nenhum exemplo for informado, os templates poderão ser rejeitados pelo Facebook.',
    expression_643: 'Campo obrigatório',
    expression_644: 'Os nomes devem ser sempre em letra minúscula, números e/ou underline. Caracteres especiais não são aceitos.',
    expression_645: 'Categoria da mensagem',
    expression_646: 'Escolha uma categoria...',
    expression_647: 'Idioma',
    expression_648: 'Escolha um idioma...',
    expression_649: 'Selecione os blocos de construção do template',
    expression_650: 'Cabeçalho',
    expression_651: 'Corpo',
    expression_652: 'Rodapé',
    expression_653: 'Botões',
    expression_654: 'Digite o texto do cabeçalho do seu template aqui...',
    expression_655: 'caracteres',
    expression_656: 'variável',
    expression_657: 'Digite o texto principal do seu template...',
    expression_658: 'Digite o texto do rodapé do seu template aqui...',
    expression_659: 'Adicionar botão',
    expression_660: 'Botão',
    expression_661: 'Resposta rápida',
    expression_662: 'Digite o texto da resposta rápida...',
    expression_663: 'Digite o texto do botão...',
    expression_664: 'Digite o número de telefone...',
    expression_665: 'Digite o texto do CTA...',
    expression_666: 'Digite a URL...',
    expression_667: 'Escolha o tipo e adicione um botão.',
    expression_668: 'Exemplo de Template',
    expression_669: 'Você não usou nenhuma variável. Isso poderá prejudicar a aprovação do seu template junto ao Facebook.',
    expression_670: 'Botão Url',
    expression_671: 'Prévia do Template',
    expression_672: 'Seu cabeçalho aparecerá aqui...',
    expression_673: 'Seu rodapé aparecerá aqui...',
    expression_674: 'Seu modelo foi enviado para aprovação!',
    expression_675: 'O Facebook pode demorar até',
    expression_676: '5 dias úteis',
    expression_677: 'para aprovar seu modelo HSM.',
    expression_678: 'Ver prévia',
    expression_679: 'Preencha os campos obrigatórios',
    expression_680: 'Salvar e continuar',
    expression_681: 'O tamanho máximo permitido por arquivo é de {size}.',
    expression_682: 'Verifique o arquivo',
    expression_683: 'Atenção!',
    expression_684: 'Tipo de arquivo não permitido.',
    expression_685: 'Tipo permitido: PDF.',
    expression_686: 'Cadastrar novo usuário',
    expression_687: 'Nível de acesso',
    expression_688: 'Supervisor',
    expression_689: 'Administrador',
    expression_690: 'Salvar usuário',
    expression_691: 'Adicionar Contato à carteira',
    expression_692: 'Nenhum atendente...',
    expression_693: 'Adicionar',
    expression_694: 'Enviar e-mail',
    expression_695: 'Destinatário:',
    expression_696: 'Excluir',
    expression_697: 'A resposta de qualquer e-mail enviado pelo sistema chegará na caixa postal:',
    expression_698: 'Certifique-se que essa caixa postal seja válida e acessível por você.',
    expression_699: 'Assunto',
    expression_700: 'Campanha retomada',
    expression_701: 'Status da Negociação',
    expression_702: 'Preencha todos os campos acima.',
    expression_703: 'Enviar mídias',
    expression_704: 'Clique ou arraste os arquivos até aqui.',
    expression_705: 'Tipos permitidos: JPG, JPEG, PNG, WEBP, PDF, MP3, DOC, DOCX, XLS e XLSX.',
    expression_706: 'Legenda...',
    expression_707: 'Histórico de Protocolos',
    expression_708: 'Data',
    expression_709: 'Nenhum histórico de protocolos disponível.',
    expression_710: 'Enviar Localização',
    expression_711: 'Digite o endereço e aperte enter ou clique em buscar',
    expression_712: 'Buscar',
    expression_713: 'Informações do protocolo',
    expression_714: 'Enviar SMS',
    expression_715: 'Digite a mensagem:',
    expression_716: 'Transferir protocolo',
    expression_717: 'Enviar V-card',
    expression_718: 'Editar departamento',
    expression_719: 'Deseja pausar essa campanha?',
    expression_720: 'Editar meta',
    expression_721: 'Excluir meta',
    expression_722: 'Editar categoria',
    expression_723: 'Editar Contato',
    expression_724: 'Editar qualificação',
    expression_725: 'Editar configurações do plano',
    expression_726: 'Selecione o e-mail do administrador',
    expression_727: 'Selecione um contato...',
    expression_728: 'Digite o código de 4 dígitos',
    expression_729: 'Código validado com sucesso!',
    expression_730: 'Código inválido!',
    expression_731: 'Enviar código de verificação',
    expression_732: 'Reenviar código',
    expression_733: 'Validar!',
    expression_734: 'Editar resposta rápida',
    expression_735: 'Deseja retomar a campanha?',
    expression_736: 'Editar tag',
    expression_737: 'Editar tarefa',
    expression_738: 'Tarefa atribuída à',
    expression_739: 'Tarefa criada por',
    expression_740: 'Você não tem permissão para editar esse campo.',
    expression_741: 'Escolha um status...',
    expression_742: 'Excluir tarefa',
    expression_743: 'Importação de leads',
    expression_744: 'Regras da Importação:',
    expression_745: 'Os arquivos devem estar em formato .CSV ou .XLS (Excel) e possuir até 3 (três) colunas:',
    expression_746: 'A coluna "EMAIL" é opcional;',
    expression_747: 'Os números de telefone devem seguir o padrão internacional (DDI + DDD + Número). Exemplo: 5511988887777',
    expression_748: 'O limite de contatos importados por arquivo é de 2 mil (dois mil) contatos.',
    expression_749: 'Os arquivos devem possuir apenas uma "aba" contendo as colunas descritas acima.',
    expression_750: 'Baixar modelo',
    expression_751: 'Importar arquivo',
    expression_752: 'Estamos validando seus leads...',
    expression_753: 'Avisaremos com uma notificação assim que todos os leads tiverem sido importados.',
    expression_754: 'números inválidos de',
    expression_755: 'Alguns contatos da sua lista apresentam erro no padrão numérico. Você poderá fazer upload de outro arquivo com as correções necessárias ou prosseguir com a importação eliminando os números inválidos.',
    expression_756: 'Veja abaixo a lista dos números com problema.',
    expression_757: 'Carregar outra lista',
    expression_758: 'Eliminar contatos inválidos',
    expression_759: 'Linha',
    expression_760: 'Erro',
    expression_761: 'Ótimo! Agora escolha qual canal e/ou tags esses contatos serão vinculados.',
    expression_762: 'Estamos processando sua lista de contatos.',
    expression_763: 'Isso pode demorar um pouco à depender do tamanho. Seja paciente.',
    expression_764: 'Importação concluída.',
    expression_765: 'Não possui número ou os cabeçalhos não foram alterados.',
    expression_766: 'Continuar importação',
    expression_767: 'Você precisar gerar um token junto à este fornecedor para integrar.',
    expression_768: 'Obter token!',
    expression_769: 'Sobre o RD Station CRM',
    expression_770: 'Controle seu processo comercial e aumente vendas usando o novo CRM da RD Station. É hora de jogar as planilhas fora! Registre automaticamente suas ações, nunca esqueça de fazer follow-up e centralize tudo em um só lugar.',
    expression_771: 'Sobre o Agendor',
    expression_772: 'O Agendor é uma plataforma de CRM e gestão comercial com versões web e mobile (Android e iOS) que funciona como um painel de controle para o gestor comercial, e um assistente pessoal de vendas para equipes de vendas B2B.',
    expression_773: 'Sobre o HubSpot',
    expression_774: 'Resumidamente, o CRM da HubSpot é um software que permite controlar o processo de vendas com facilidade, permitindo um gerenciamento completo de leads, prospects e pipeline de vendas.',
    expression_775: 'Sobre o Nectar CRM',
    expression_776: 'Tudo que você precisa para alta performance em vendas! Acompanhe suas oportunidades de venda em detalhes através de uma pipeline visual, intuitiva e completa.',
    expression_777: 'Sobre o Pipedrive',
    expression_778: 'O Pipedrive é uma plataforma do tipo CRM criada para facilitar a gestão de vendas de empresas em crescimento. A ferramenta tem como base a venda a partir de atividades, por isso o Pipedrive foi projetado para atender as necessidades dos gestores e vendedores.',
    expression_779: 'Sobre o RBX Soft',
    expression_780: 'A plataforma é preparada para pacotes de serviços, multiempresas e franquias. Uma solução modular, podendo ser customizada de acordo com a necessidade dos clientes. O foco está na constante transformação e evolução lógica do crescimento do mercado super competitivo e dinâmico.',
    expression_781: 'Sobre o Followize',
    expression_782: 'Followize é um software de gestão de leads desenvolvido para apoiar empresas que recebem leads através da internet e tem dificuldade em gerenciar as novas demandas desde o primeiro contato até a decisão de compra.',
    expression_783: 'Sobre o BSMS',
    expression_784: 'Integração com a plataforma BSMS.',
    expression_785: 'Sobre o API Oficial Meta',
    expression_786: 'Integração com API oficial do WhatsApp.',
    expression_787: 'Sobre o VOIP',
    expression_788: 'Integração com parceiro para chamadas Voip.',
    expression_789: 'Sobre a WATI',
    expression_790: 'Como funciona essa integração',
    expression_791: 'Ao integrar o seu CRM com o RDStation você compartilhará automaticamentente as informações dos seus leads com esse fornecedor. As informações que podem ser enviadas são as seguintes: Nome (obrigatório), Empresa, Telefone (obrigatório) e E-mail (obrigatório).',
    expression_792: 'Ao integrar o seu CRM com o Agendor você compartilhará automaticamentente as informações dos seus leads com esse fornecedor. As informações que podem ser enviadas são as seguintes: Nome (obrigatório), Telefone (obrigatório) e E-mail (obrigatório).',
    expression_793: 'Ao integrar o seu CRM com o HubSpot você compartilhará automaticamentente as informações dos seus leads com esse fornecedor. As informações que podem ser enviadas são as seguintes: Nome (obrigatório), E-mail (obrigatório) e Telefone (obrigatório).',
    expression_794: 'Ao integrar o seu CRM com o NectarCRM você compartilhará automaticamentente as informações dos seus leads com esse fornecedor. As informações que podem ser enviadas são as seguintes: Nome (obrigatório), E-mail (obrigatório) e Telefone (obrigatório).',
    expression_795: 'Ao integrar o seu CRM com o PipeDrive você compartilhará automaticamentente as informações dos seus leads com esse fornecedor. As informações que podem ser enviadas são as seguintes: Nome (obrigatório), E-mail (obrigatório) e Telefone (obrigatório).',
    expression_796: 'Ao integrar o seu CRM com o RBXSoft você poderá entregar automaticamente os boletos para seus clientes ao digitarem CPF ou CNPJ correspondentes ao cadastro junto à sua empresa.',
    expression_797: 'Ao integrar o seu CRM com o Followize você compartilhará automaticamentente as informações dos seus leads com esse fornecedor. As informações que podem ser enviadas são as seguintes: Nome (obrigatório), E-mail (obrigatório) e Telefone (obrigatório).',
    expression_798: 'Integração não realizada! Você precisa informar o token para prosseguir.',
    expression_799: 'Baixar PDF',
    expression_800: 'Diferenças nos logs',
    expression_801: 'Antes',
    expression_802: 'Depois',
    expression_803: 'Detalhes da Notificação',
    expression_804: 'Ver tarefas',
    expression_805: 'Marcar como lido',
    expression_806: 'Marcar como não lido',
    expression_807: 'Esse lead já possui um protocolo (chamado) em aberto.',
    expression_808: 'Pesquisar campanha',
    expression_809: 'Final',
    expression_810: 'Limpar filtros',
    expression_811: 'Pesquisar',
    expression_812: 'Número do canal',
    expression_813: 'Pesquisar um lead',
    expression_814: 'Data inicial',
    expression_815: 'Data final',
    expression_816: 'Status do protocolo',
    expression_817: 'Todos',
    expression_818: 'Nome',
    expression_819: 'Telefone',
    expression_820: 'Pesquisar um usuário',
    expression_821: 'Enviar mensagem HSM',
    expression_822: 'Mensagens modelo são processadas individualmente, com aplicação de taxas por envio.',
    expression_823: 'Nenhum template cadastrado.',
    expression_824: 'Editar Variáveis',
    expression_825: 'Tipos permitidos: MPEG, MP4.',
    expression_826: 'Pesquisa de Satisfação',
    expression_827: 'Alterar senha do usuário',
    expression_828: 'A senha não pode ser vazia.',
    expression_829: 'Digite a nova senha:',
    expression_830: 'Salvar senha',
    expression_831: 'Ação em massa na Carteira',
    expression_832: 'Escolha uma ação...',
    expression_833: 'Remover leads da carteira',
    expression_834: 'Transferir leads',
    expression_835: 'Remover leads',
    expression_836: 'Variáveis disponíveis',
    expression_837: 'Você poderá utilizar as variáveis abaixo para inserir informações dinamicamente às mensagens.',
    expression_838: 'Insere o nome do lead.',
    expression_839: 'Insere o link para inscrição no canal de campanhas do Telegram.',
    expression_840: 'Insere o nome do atendente.',
    expression_841: 'Insere o nome do departamento.',
    expression_842: 'Insere o número do protocolo.',
    expression_843: 'Formatação de Texto',
    expression_844: 'Para formatar o texto das mensagens, você deve adicionar os caracteres abaixo, antes e depois de cada palavra que deseja modificar. Por exemplo, digite:',
    expression_845: 'Resultado:',
    expression_846: 'asterisco:',
    expression_847: 'Adiciona',
    expression_848: 'negrito',
    expression_849: 'itálico',
    expression_850: 'riscado',
    expression_851: 'ao texto.',
    expression_852: 'underline',
    expression_853: 'acento',
    expression_854: 'Detalhes da midia',
    expression_855: 'Download',
    expression_856: 'Chamada Voip',
    expression_857: 'Iniciar ligação',
    expression_858: 'R$ 0.95 por minuto',
    expression_859: 'Criar menu principal',
    expression_860: 'Criar submenu',
    expression_861: 'Detalhes da campanha',
    expression_862: 'Essa campanha foi concluída com sucesso!',
    expression_863: 'Essa campanha está sendo executada.',
    expression_864: 'Esta campanha está agendada.',
    expression_865: 'Conteúdo',
    expression_866: 'Mídia',
    expression_867: 'Data da criação',
    expression_868: 'Data da finalização',
    expression_869: 'Campanha criada por',
    expression_870: 'Cancelar envio',
    expression_871: 'Deseja mesmo cancelar essa campanha?',
    expression_872: 'Sim, cancelar',
    expression_873: 'Tipos permitidos: JPG, JPEG, PNG, MP4 e PDF.',
    expression_874: 'Escolha o departamento que deverá receber esses protocolos.',
    expression_875: 'Escolha um atendente para receber esses protocolos.',
    expression_876: 'Digite seu nome:',
    expression_877: 'Informe seu e-mail:',
    expression_878: 'Seu WhatsApp:',
    expression_879: 'Aceito receber promoções.',
    expression_880: 'Recebemos seu contato!',
    expression_881: 'Agradecemos o interesse. Envie uma mensagem para o nosso WhatsApp.',
    expression_882: 'Deseja excluir esta categoria?',
    expression_883: 'Deseja excluir este resposta?',
    expression_884: 'Erro ao enviar mensagem, tente novamente',
    expression_885: 'Deseja excluir esta tag?',
    expression_886: 'O tamanho máximo permitido por arquivo é de 2MB.',
    expression_887: 'Deseja excluir este vinculo?',
    expression_888: 'Essa ação excluirá o vínculo dessa tag com o contato em questão.',
    expression_889: 'Digite uma nota para salvar.',
    expression_890: 'Essa ação excluirá o vínculo desse lead com o usuário em questão.',
    expression_891: 'Contato adicionado com sucesso!',
    expression_892: 'Tipos permitidos: JPG, JPEG e PNG.',
    expression_893: 'Acesso criado com sucesso!',
    expression_894: 'Atenciosamente,',
    expression_895: 'Deseja finalizar este protocolo?',
    expression_896: 'Sim, finalizar',
    expression_897: 'Só é permitido o envio de 3 arquivos por vez.',
    expression_898: 'Deseja excluir esta meta?',
    expression_899: 'Deseja excluir essa tarefa?',
    expression_900: 'Tem certeza que deseja importar',
    expression_901: 'Sim, importar',
    expression_902: 'Deseja excluir esta notificação?',
    expression_903: 'Todos os status',
    expression_904: 'Bot cadastrado com sucesso!',
    expression_905: 'Bot editado com sucesso!',
    expression_906: 'Excluído!',
    expression_907: 'O bot foi removido.',
    expression_908: 'Cancelada!',
    expression_909: 'Campanha excluída com sucesso.',
    expression_910: 'Campanha criada com sucesso!',
    expression_911: 'Canal editado com sucesso!',
    expression_912: 'Canal cadastrado com sucesso!',
    expression_913: 'Protocolo transferido com sucesso!',
    expression_914: 'Protocolo finalizado com sucesso!',
    expression_915: 'Contato cadastrado com sucesso',
    expression_916: 'Painel de Controle',
    expression_917: 'Departamento cadastrado com sucesso!',
    expression_918: 'Departamento editado com sucesso!',
    expression_919: 'O departamento foi removido.',
    expression_920: 'A campanha foi pausada com sucesso.',
    expression_921: 'A campanha foi retomada com sucesso.',
    expression_922: 'Esta campanha está pausada.',
    expression_923: 'Pausada',
    expression_924: 'Fazer upload de arquivos',
    expression_925: 'Excluída!',
    expression_926: '',
    expression_927: 'Mensagens removidas da fila de envio!',
    expression_928: 'Categoria cadastrado com sucesso!',
    expression_929: 'Categoria editado com sucesso!',
    expression_930: 'A categoria foi removida.',
    expression_931: 'Tag vinculada com sucesso!',
    expression_932: 'A tag foi desvinculada.',
    expression_933: 'Informações alteradas com sucesso!',
    expression_934: 'Gerando arquivo...',
    expression_935: 'Não se preocupe, avisaremos com uma notificação quando finalizarmos.',
    expression_936: 'E-mail informado não está cadastrado no sistema.',
    expression_937: 'Enviamos uma mensagem para o seu e-mail. Clique no link da mensagem para confirmar seu endereço eletrônico.',
    expression_938: 'Verifique sua caixa postal, incluindo a lixeira/spam.',
    expression_939: 'E-mail enviado!',
    expression_940: 'Qualificação cadastrada com sucesso!',
    expression_941: 'Qualificação editada com sucesso!',
    expression_942: 'A qualificação foi removida.',
    expression_943: 'Anotação criada com sucesso!',
    expression_944: 'Qualificação editado com sucesso!',
    expression_945: 'O qualificação foi removida.',
    expression_946: 'Excluído!',
    expression_947: 'A notificação foi removida.',
    expression_948: 'As notificações foram removidas.',
    expression_949: 'Operador cadastrado com sucesso!',
    expression_950: 'O atendente foi removido.',
    expression_951: 'Exportação em andamento.',
    expression_952: 'Assim que concluir, iremos exibir uma notificação.',
    expression_953: 'Resposta cadastrada com sucesso!',
    expression_954: 'Resposta editada com sucesso!',
    expression_955: 'A resposta foi removida.',
    expression_956: 'A cada 13 dias você deve ligar o dispositivo para que o WhatsApp mantenha sua conta conectada. Caso contrário a comunicação será interrompida e você deverá repetir o processo de conexão.',
    expression_957: 'Gerar QRCode',
    expression_958: 'Sucesso',
    expression_959: 'Tag cadastrada com sucesso!',
    expression_960: 'Tag editada com sucesso!',
    expression_961: 'A tag foi removida.',
    expression_962: 'Tarefa cadastrada com sucesso!',
    expression_963: 'Tarefa editada com sucesso!',
    expression_964: 'A tarefa foi removida.',
    expression_965: 'Template editado com sucesso!',
    expression_966: 'Template foi removido.',
    expression_967: 'O usuário foi removido.',
    expression_968: 'Acesso restaurado com sucesso!',
    expression_969: 'O que deseja fazer?',
    expression_970: 'O lead foi removido da carteira.',
    expression_971: 'Carteira vinculada com sucesso!',
    expression_972: 'Os leads foram removidos da carteira!',
    expression_973: 'Contatos transferidos com sucesso!',
    expression_974: 'Widget editado com sucesso!',
    expression_975: 'Deseja mesmo enviar essa campanha?',
    expression_976: 'O envio iniciará em',
    expression_977: 'O envio será realizado nos próximos minutos.',
    expression_978: 'Sim, enviar!',
    expression_979: 'Tipos permitidos: JPG, JPEG, PNG e MP4.',
    expression_980: 'do Departamento',
    expression_981: 'do Canal',
    expression_982: 'Página não encontrada.',
    expression_983: 'Voltar ao dashboard',
    expression_984: 'Para recuperar sua senha, digite o e-mail cadastrado.',
    expression_985: 'Enviar link de recuperação por e-mail',
    expression_986: 'Link enviado!',
    expression_987: 'Enviamos um e-mail para',
    expression_988: 'com as informações de como recuperar sua senha. Verifique sua caixa postal, incluindo a Lixeira/Spam.',
    expression_989: 'Fazer login',
    expression_990: 'Agora, crie uma nova senha de acesso:',
    expression_991: 'Salvar nova senha',
    expression_992: 'Ótimo,',
    expression_993: 'Senha alterada com sucesso!',
    expression_994: 'Senha muito curta.',
    expression_995: 'Deseja excluir este lead da carteira?',
    expression_996: 'Deseja excluir este atendente?',
    expression_997: 'Não é permitido alterar o nível de acesso quando se tem vinculo de atendente em algum canal.',
    expression_998: 'Mudar senha',
    expression_999: 'Logs',
    expression_1000: 'Canais Vinculados',
    expression_1001: 'Clique no nome do canal para vincular esse usuário',
    expression_1002: 'Esse usuário ainda não possui acesso à nenhum canal.',
    expression_1003: 'Logs de Atividade',
    expression_1004: 'ID da Origem',
    expression_1005: 'Diferenças',
    expression_1006: 'Endereço de IP',
    expression_1007: 'Ver diferenças',
    expression_1008: 'Nenhum log registrado para esse usuário.',
    expression_1009: 'Carteira de Contatos',
    expression_1010: 'Ação em massa',
    expression_1011: 'Nenhum lead cadastrado nessa carteira.',
    expression_1012: 'Disponibilidade',
    expression_1013: 'Remover usuário',
    expression_1014: 'Online',
    expression_1015: 'Offline',
    expression_1016: 'Em',
    expression_1017: 'departamentos/canais',
    expression_1018: 'Nenhum usuário foi cadastrado até o momento.',
    expression_1019: 'Deseja excluir este usuário?',
    expression_1020: 'Janeiro',
    expression_1021: 'Fevereiro',
    expression_1022: 'Março',
    expression_1023: 'Abril',
    expression_1024: 'Maio',
    expression_1025: 'Junho',
    expression_1026: 'Julho',
    expression_1027: 'Agosto',
    expression_1028: 'Setembro',
    expression_1029: 'Outubro',
    expression_1030: 'Novembro',
    expression_1031: 'Dezembro',
    expression_1032: 'Hoje',
    expression_1033: 'Mês',
    expression_1034: 'Semana',
    expression_1035: 'Dia',
    expression_1036: 'Lista',
    expression_1037: 'Nenhuma tarefa agendada para essa data.',
    expression_1038: 'Relatório de E-mail',
    expression_1039: 'Relatório de Envios HSM',
    expression_1040: 'Relatório de SMS',
    expression_1041: 'Relatório de Ligações Voip',
    expression_1042: 'Pesquisar e-mails',
    expression_1043: 'Nenhum e-mail foi enviado até o momento.',
    expression_1044: 'Pesquisar HSM',
    expression_1045: 'Nenhum HSM foi enviado até o momento.',
    expression_1046: 'Pesquisar SMS',
    expression_1047: 'Nenhum SMS foi enviado até o momento.',
    expression_1048: 'Pesquisar Voip',
    expression_1049: 'Nenhuma ligação foi realizada até o momento.',
    expression_1050: 'Distribuia os leads de forma igualitária para seus atendentes.',
    expression_1051: 'e',
    expression_1052: 'Relatório de Pesquisa de Satisfação',
    expression_1053: 'Fotos e vídeos',
    expression_1054: 'Taxa de abertura',
    expression_1055: 'Nenhum dado disponível.',
    expression_1056: 'Status (beta)',
    expression_1057: 'Webhooks',
    expression_1058: 'Tokens',
    expression_1059: 'Adicionar token',
    expression_1060: 'Mensagens recebidas',
    expression_1061: 'Status da mensagens',
    expression_1062: 'Informe o webhook que receberá as mensagens do seu canal.',
    expression_1063: 'Informe o webhook que receberá os status das mensagens.',
    expression_1064: 'Exemplos de payload',
    expression_1065: 'Ver exemplo de payload',
    expression_1066: 'Expiração',
    expression_1067: 'Token',
    expression_1068: 'Nunca',
    expression_1069: '7 dias',
    expression_1070: '24 horas',
    expression_1071: '12 horas',
    expression_1072: '4 horas',
    expression_1073: 'Editar token',
    expression_1074: 'Token copiado com sucesso!',
    expression_1075: 'Escolha um período de expiração do token...',
    expression_1076: 'Clique para copiar esse token',
    expression_1077: 'Deseja excluir este token?',
    expression_1078: 'Timeline',
    expression_1079: 'Expirado',
    expression_1080: 'Prazo',
    expression_1081: 'Copiar',
    expression_1082: 'Parabéns! Você importou uma lista válida.',
    expression_1083: 'Continuar com a importação',
    expression_1084: 'Para enviar um contato no',
    expression_1085: 'use o padrão numérico internacional, incluindo DDI (código do país) e DDD (por exemplo: 5511988888888), sem espaços ou qualquer outros tipos de caracteres. Caso o contato não possua WhatsApp o número será enviado apenas como texto.',
    expression_1086: 'Enviar vCard',
    expression_1087: 'Enviar',
    expression_1088: 'Encerrado',
    expression_1089: 'Transferido',
    expression_1090: 'Rejeitado',
    expression_1091: 'Inatividade do Operador',
    expression_1092: 'Inatividade do Contato',
    expression_1093: 'Mensagem de sistema',
    expression_1094: 'Para mais informações sobre como realizar a integração via API, ',
    expression_1095: 'clique aqui para ler a documentação.',
    expression_1096: 'Você',
    expression_1097: 'Responder',
    expression_1098: 'Uso crítico do sistema',
    expression_1099: 'Você possui muitos atendimentos em aberto! Isso pode causar lentidão no uso do sistema, devido a quantidade de informações sendo processadas no seu computador. Para um uso saudável do sistema, aconselhamos fortemente que você finalize os protocolos que já tiverem com assunto encerrado ou ainda que dê para abrir chamado posteriormente.',
    expression_1100: 'Nenhum canal vinculado',
    expression_1101: 'Canal vinculado',
    expression_1102: 'Migração',
    expression_1103: 'Realizar migração desse canal para outro deploy',
    expression_1104: 'Subdomínio',
    expression_1105: 'Domínio',
    expression_1106: 'ID do Canal',
    expression_1107: 'Migração iniciada! Enviaremos uma notificação quando concluirmos.',
    expression_1108: 'Essa ação é irreversível e irá remover as tokens da sessão atual do WhatsApp.',
    expression_1109: 'Alerta de uso inadequado! Clique para saber mais.',
    expression_1110: 'Ver conversa',
    expression_1111: 'Você tem uma nova mensagem!',
    expression_1112: 'te mandou uma nova mensagem!',
    expression_1113: 'Chat interno',
    expression_1114: 'Esse protocolo já está sendo atendido ou finalizado.',
    expression_1115: 'Atenção: Caso deseje importar números internacionais, por favor, importe apenas uma lista contendo os números daquele país em específico. Não deve-se misturar contatos de países diferentes na mesma lista.',
    expression_1116: 'Nenhum',
    expression_1117: 'RANKING DE CANAIS',
    expression_1118: 'RANKING DE DEPARTAMENTOS',
    expression_1119: 'RANKING DE ATENDENTES',
    expression_1120: 'Informe a URL aqui...',
    expression_1121: 'Campanhas por Lista de Transmissão',
    expression_1122: 'Campanhas por Status',
    expression_1123: 'Informe o webhook que receberá os status das campanhas nessa modalidade de envio.',
    expression_1124: 'Filtros',
    expression_1125: 'às',
    expression_1126: 'Nenhuma mensagem',
    expression_1127: 'Baixar arquivo...',
    expression_1128: 'Mudar arquivo',
    expression_1129: 'Essa funcionalidade está em fase de testes.',
    expression_1130: 'Você não pode habilitar esse módulo se a API estiver habilitada.',
    expression_1131: 'Você não pode habilitar esse módulo se o Chat-bot ou as Notificações estiverem habilitadas.',
    expression_1132: 'Para usar a API da melhor forma, você poderá precisar da ajuda de um profissional qualificado. Os módulos de Chat-Bot e Notificações não podem funcionar enquando esse módulo estiver habilitado. Consulte nossa documentação de API para mais informações.',
    expression_1133: 'Nenhum token foi cadastrado.',
    expression_1134: 'O Contato deve ter se comunicado com o canal anteriormente. Além dos campos obrigatórios, o RD Station precisa da informação de “Empresa” para cadastrar o Contato. Portanto, se o Contato tiver esse campo preenchido no CRM, enviaremos essa informação. Caso contrário, enviaremos o tipo do seu canal no lugar do campo “Empresa”. Por exemplo: “WhatsApp - ',
    expression_1135: 'Comunicado importante.',
    expression_1136: 'Conforme já orientado pela equipe de Suporte do',
    expression_1137: 'devido ao alto fluxo de envio em massa o WhatsApp vem restringindo cada vez mais e fazendo bloqueios por tal motivo.',
    expression_1138: 'Atentem-se para que não haja denúncias e bloqueios das suas contas devido ao uso excessivo desta funcionalidade.',
    expression_1139: 'Sempre que possível, leia nossas dicas antes de fazer uma postagem para melhorar sua performance.',
    expression_1140: 'Em caso de dúvida, por favor, entre em contato com nosso suporte.',
    expression_1141: 'Ok, entendi!',
    expression_1142: 'Funcionalidade desativada temporariamente.',
    expression_1143: 'Países',
    expression_1144: 'Estados',
    expression_1145: 'Cidades',
    expression_1146: 'Executando',
    expression_1147: 'Dispositivos',
    expression_1148: 'Visitas',
    expression_1149: 'Relatório de Tráfego da Campanha',
    expression_1150: 'Resumo da campanha',
    expression_1151: 'Ver detalhes',
    expression_1152: 'Nome da campanha',
    expression_1153: 'Total de Visitas',
    expression_1154: 'por dia',
    expression_1155: 'Visitantes Únicos',
    expression_1156: 'Navegadores',
    expression_1157: 'Sistemas Operacionais',
    expression_1158: 'Contato removido com sucesso!',
    expression_1159: 'Tem certeza que quer excluir esse contato?',
    expression_1160: 'Excluir contato',
    expression_1161: 'Conexão com o Telegram',
    expression_1162: 'Escaneie o QR-Code para conectar sua conta do WhatsApp',
    expression_1163: '1) Abra o WhatsApp no seu celular.',
    expression_1164: '2) Clique em',
    expression_1165: '"Mais opções" ou "Configurações" e selecione "Aparelhos conectados".',
    expression_1166: '3) Aponte seu telefone para esta tela para capturar o código.',
    expression_1167: 'Enviar código via SMS',
    expression_1168: 'Confirmar número de telefone',
    expression_1169: 'Você receberá um SMS com o código de verificação no número abaixo:',
    expression_1170: 'Insira o código de verificação',
    expression_1171: 'Você receberá um código via SMS. Informe abaixo esse código:',
    expression_1172: 'Configurando ambiente...',
    expression_1173: 'Seu código foi validado com sucesso! Agora, estamos preparando seu ambiente. Isso pode demorar alguns instantes.',
    expression_1174: 'Sua conta está conectada!',
    expression_1175: 'Parabéns! Agora você já pode se comunicar pelo Telegram dentro do nosso CRM.',
    expression_1176: 'Perdemos a conexão com sua conta de Telegram.',
    expression_1177: 'Caso persista, entre em contato com nosso suporte.',
    expression_1178: 'Conexão Telegram',
    expression_1179: 'Monitoramento de Tráfego',
    expression_1180: 'Habilite essa funcionalidade para gerar um link encurtado e adicionar códigos de rastreio à sua campanha.',
    expression_1181: 'O monitoramento só está disponível para campanhas contendo arquivos. Adicione um arquivo no card anterior: Conteúdo da Campanha',
    expression_1182: 'Insira um arquivo',
    expression_1183: 'Desativar',
    expression_1184: 'Ativar',
    expression_1185: 'Título do Link',
    expression_1186: 'Esse título aparecerá junto a miniatura da imagem no link compartilhado.',
    expression_1187: 'Código do Google Analytics',
    expression_1188: 'Exemplo de ID de métrica: G-TWNTT9BWDL.',
    expression_1189: 'Código do Google Tag Manager',
    expression_1190: 'Exemplo de ID de métrica: G-TWNTT9BWDL.',
    expression_1191: 'Código do Pixel do Facebook',
    expression_1192: 'Exemplo de ID do Pixel: 1049737222095654.',
    expression_1193: 'Escolha um canal de transmissão',
    expression_1194: 'Você precisa criar um canal de transmissão para gerar suas campanhas!',
    expression_1195: 'Insere o link para o seu canal do WhatsApp.',
    expression_1196: 'Conexão WhatsApp',
    expression_1197: 'Envios de HSM',
    expression_1198: 'Lista de templates HSM sincronizada com sucesso!',
    expression_1199: 'Sessão',
    expression_1200: 'Entregue',
    expression_1201: 'Lida',
    expression_1202: 'Não enviado',
    expression_1203: 'Nome do arquivo',
    expression_1204: 'Espaço de texto insuficiente',
    expression_1205: 'Não foi possível adicionar a variável',
    expression_1206: 'pois não há espaço de texto.',
    expression_1207: 'Pré visualização de payload',
    expression_1208: 'Exemplo',
    expression_1209: 'Relatório de Webhooks Falhos',
    expression_1210: 'Pesquisar webhooks',
    expression_1211: 'Logs webhooks',
    expression_1212: 'Nenhum erro foi registrado.',
    expression_1213: 'Retorno da API Oficial',
    expression_1214: 'Retorno',
    expression_1215: 'Reenviar',
    expression_1216: 'Mensagem reenviada!',
    expression_1217: 'Um novo envio foi feito para a API oficial.',
    expression_1218: 'lead(s) enviado(s)',
    expression_1219: 'Não foi possível verificar se o lead já existe no canal, selecione novamente.',
    expression_1220: 'Criar grupo de envio',
    expression_1221: 'Gestão de grupos de envio',
    expression_1222: 'Grupos',
    expression_1223: 'Todos os grupos',
    expression_1224: 'Excluir grupo',
    expression_1225: 'canais encontrados',
    expression_1226: 'Novo grupo',
    expression_1227: 'Grupo selecionado',
    expression_1228: 'Nome do grupo',
    expression_1229: 'Tem certeza que quer excluir esse grupo ?',
    expression_1230: 'Criar grupo',
    expression_1231: 'Selecione um grupo',
    expression_1232: 'Editar nome do grupo',
    expression_1233: 'Voltar para seleção de grupo',
    expression_1234: 'Grupo criado com sucesso!',
    expression_1235: 'Grupo removido com sucesso!',
    expression_1236: 'Canal adicionado com sucesso!',
    expression_1237: 'Os grupos de envio servem para organizar pequenos grupos de canais nomeados com intuito de facilitar os destinatários de suas campanhas.',
    expression_1238: 'Gerencie esta ferramenta e aproveite suas funcionalides.',
    expression_1239: 'O que é grupo de envio?',
    expression_1240: 'Canais Oficiais não podem ser incluídos em grupos!!',
    expression_1241: 'Criado',
    expression_1242: '-> O usuário de ID #{id} não possui acesso à esse canal. Favor verificar com o suporte!',
    expression_1243: 'Não é possível desvincular do canal sem deletar antes o atendente.',
    expression_1244: 'Aguarde',
    expression_1245: 'O template foi enviado para exclusão, aguarde a resposta do Meta. Caso a exclusão não ocorra de imediato, sincronize clicando no botão "Sincronizar templates".',
    expression_1246: 'Sincronizar templates.',
    expression_1247: 'Ocultar outros idiomas',
    expression_1248: 'Ocultar ou exibir templates de idiomas diferente do sistema.',
    expression_1249: 'Exibir outros idiomas',
    expression_1250: "Por favor, selecione uma planilha do tipo .csv, .xls ou .xlsx",
    expression_1251: "Relatório de Tráfego do Chat-bot",
    expression_1252: "Cliques mês atual",
    expression_1253: "Cliques",
    expression_1254: "Bem vindo ao relatório de cliques de seu chat-bot",
    expression_1255: "Para visualizar as estastíticas, selecione um canal",
    expression_1256: "Níveis de chatbot",
    expression_1257: "Ver nível principal",
    expression_1258: "Estatísticas de cliques Chatbot",
    expression_1259: "O canal selecionado não possui informações de cliques para serem exibidas",
    expression_1260: "Selecione outro canal",
    expression_1261: "Informe",
    expression_1262: 'Filtro de cliques',
    expression_1263: "WhatsApp Web QR (Não oficial)",
    expression_1264: "Você não tem permissão para mudar.",
    expression_1265: 'Sobre WhatsApp Web',
    expression_1266: 'Integração com WhatsApp Web não oficial.', /*Sem referência para seu contexto*/
    expression_1267: 'Desconectar',
    expression_1268: 'Sessão desconectada', /*Sem referência para seu contexto*/
    expression_1269: 'Conectado',
    expression_1270: 'Não é possível habilitar pois "API Oficial Meta" está habilitado.',
    expression_1271: 'Não é possível habilitar pois "QR Code" está habilitado.',
    expression_1272: 'Abrir agenda',
    expression_1273: 'Fechar agenda',
    expression_1274: 'Nenhum filtro além de canal selecionado para pesquisa',
    expression_1275: 'Conectar',
    expression_1276: 'Desconectado',
    expression_1277: 'Cadastre sua campanha ou exporte relatórios',
    expression_1278: "Habilite e configure uma integração",
    expression_1279: "Gerar Secret",
    expression_1280: "Você precisa ter uma token válida para integrar.",
    expression_1281: "Desconecte com o WhatsApp Business API para poder intergrar com o WhatsApp",
    expression_1282: "Desconecte com o WhatsApp para poder intergrar com o WhatsApp Business API",
    expression_1283: "Houve um erro ao gerar sua secret",
    expression_1284: "Token e Secret geradas com sucesso",
    expression_1285: "Selecionar todos os canais",
    expression_1286: "Desmarcar todos os canais",
    expression_1287: "Conversas",
    expression_1288: "Tipo",
    expression_1289: 'Continuar',
    expression_1290: 'Agentes Online',
    expression_1291: 'Agentes',
    expression_1292: 'Conversas Concluídas',
    expression_1293: 'Concluídas',
    expression_1294: 'Conversas',
    expression_1295: 'Conversas Não Concluídas',
    expression_1296: 'Mensagens',
    expression_1297: 'Negócios Vencidos',
    expression_1298: 'Vencidos',
    expression_1299: 'Ciclo de Vendas',
    expression_1300: 'Ciclo',
    expression_1301: 'Dias',
    expression_1302: 'Volume de Oportunidades',
    expression_1303: 'Volume',
    expression_1304: 'Conversão de Vendas(30 dias)',
    expression_1305: 'Ganhos',
    expression_1306: "Métricas de interação e engajamento dos usuários",
    expression_1307: "Desempenho de campanhas e métricas de e-mail",
    expression_1308: "Relatórios de mensagens de serviço",
    expression_1309: "Net Promoter Score e satisfação do cliente",
    expression_1310: "Métricas de desempenho e produtividade",
    expression_1311: "Estatísticas de envio e entrega de SMS",
    expression_1312: "Relatórios de chamadas e comunicação por voz",
    expression_1313: "Análise de conversas e interações",
    expression_1314: "Monitoramento e análise de webhooks",
    expression_1315: "Métricas de chatbots e auto atendimento",
    expression_1316: "Análise de oportunidades e conversões",
    expression_1317: "Visualize e analise dados importantes para tomar decisões estratégicas",
    expression_1318: "Potencialize seus Relacionamentos",
    expression_1319: "Acesse o Bee CRM e transforme dados em conexões valiosas com seus clientes.",
    expression_1319_wl: "Acesse o CRM e transforme dados em conexões valiosas com seus clientes.",
    expression_1320: "Gestão Inteligente",
    expression_1321: "Centralize contatos, automatize tarefas e acompanhe oportunidades em tempo real.",
    expression_1322: "Produtividade Acelerada",
    expression_1323: "Reduza tempo em tarefas manuais e foque no que realmente importa: seus clientes.",
    expression_1324: "Segurança Garantida",
    expression_1325: "Seus dados protegidos com criptografia avançada e controles de acesso personalizados.",
    expression_1326: "Integração Completa",
    expression_1327: "Conecte-se com suas ferramentas favoritas e unifique seus processos de negócio.",
    expression_1328: "Ao continuar, você aceita os",
    expression_1328_wl: "Ao continuar, você aceita os nossos Termos de Serviço.",
    expression_1329: "Termos de Serviço",
    expression_1330: "da Bee CRM.",
    expression_1331: "Bem-vindo de volta!",
    expression_1332: "Entre com suas credenciais para acessar sua conta",
    expression_1333: "Seu email corporativo",
    expression_1334: "Sua senha",
    expression_1335: "Recuperar Acesso",
    expression_1336: "Recupere seu Acesso",
    expression_1337: "Redefina sua senha de forma rápida e segura para voltar a gerenciar seus relacionamentos.",
    expression_1338: "Segurança Avançada",
    expression_1339: "Processo protegido por criptografia e verificação em múltiplas etapas.",
    expression_1340: "Processo Rápido",
    expression_1341: "Recupere seu acesso em poucos minutos e volte a utilizar o sistema.",
    expression_1342: "Confirmação Segura",
    expression_1343: "Receba instruções detalhadas diretamente no seu email cadastrado.",
    expression_1344: "Nova Credencial",
    expression_1345: "Crie uma nova senha forte para proteger seus dados e informações.",
    expression_1346: "Sua senha foi alterada com sucesso. Agora você pode fazer login com sua nova senha.",
    expression_1347: "Visualize notificações de relatórios ou atualizações do sistema.",
    expression_1348: "Mensagens e Notificações",
    expression_1349: "Gerenciamento de contas",
    expression_1350:"Em desenvolvimento",
    expression_1351: "Marcar todas como lidas",
    expression_1352: "Marcar todas como não lidas",
     /*TRADUCOES Channel_Flow*/
    /*TRADUCOES CompanyInformation*/
    expression_1353: "Nome da Empresa",
    expression_1354: "Equipes adicionadas",
    expression_1355: "Remover equipe",
    expression_1356: "Setor de atuação",
    expression_1357: "Selecione o setor da sua empresa",
    expression_1358: "Preencha as informações básicas da sua empresa para iniciar o cadastro do",
    expression_1359: "Esses dados serão usados para configurar e identificar seu canal.",
    expression_1360: "Digite o nome da equipe.",
    expression_1361: "Esta equipe já foi adicionada.",
    expression_1362: "Digite o nome da empresa.",
  
    /*TRADUCOES TITLES*/
    expression_1363: "Selecione o Canal",
    expression_1364: "Informações da Empresa",
    expression_1365: "Cadastro de Usuários",
    expression_1366: "Ativação do Canal",
    expression_1367: "Confirmação",
    expression_1368: "Próximo",

  /*TRADUCOES Avisos*/
  expression_1369: "Selecione um canal para continuar.",
  expression_1370: "O nome da empresa é obrigatório!",
  expression_1371: "Adicione pelo menos uma equipe antes de continuar.",
  expression_1372: "Adicione pelo menos um usuário.",

  expression_1373: "🎉 Cadastro Concluído! 🎉",
  expression_1374: "Seu cadastro foi concluído com sucesso!",
  expression_1375: "Fechar",
/*TRADUCOES USERS*/
    expression_1376: "Agora, vamos cadastrar o usuário que terá acesso ao canal. Defina o nome, e-mail, senha e função.",
    expression_1377: "Informe o e-mail do usuário",
    expression_1378: "Digite o nome completo do usuário",
    expression_1379: "Administradores não podem ser vinculados a equipes.",
    expression_1380: "Selecione a equipe",
    expression_1381: "Usuários adicionados:",
    expression_1382: "Este e-mail já foi adicionado.",
    expression_1383: "Este e-mail já existe no sistema.",
    expression_1384: "Erro ao verificar e-mail.",
    expression_1385: "Preencha todos os campos obrigatórios.",
    expression_1386: "E-mail inválido.",
    expression_1387: "O e-mail tem um formato inválido.",
    expression_1388: "adicionado com sucesso!",
    expression_1389: "Usuário removido com sucesso.",
    expression_1390: "Responsável por enviar, receber mensagens e gerenciar seus negócios.",
    expression_1391: "Acesso total para gerenciar configurações, usuários e mensagens.",
    expression_1392: "Pode gerenciar mensagens e configurações, mas não usuários.",
    expression_1393: "Remover usuário",
    expression_1394: "Usuário",

    /*TRADUCOES CHANNEL - Activation*/
    expression_1395: "Clique abaixo para ativar seu canal agora mesmo. Em seguida, clique em \"Ativar Canal\".",
    expression_1396: "Canal ativado com sucesso!",
    expression_1397: "Algo deu errado na ativação. Tente novamente.",
    expression_1398: "Erro ao ativar canal:",
    expression_1399: "Erro inesperado ao ativar canal.",
    expression_1400: "Ativar Canal",
    expression_1401: "Ativando...",
    expression_1402: "Selecione um canal de comunicação",

    /*Ajuda*/
    expression_1403: "Central de Ajuda",
    expression_1404: "Suporte Bee",
    expression_1405: "Blog da Bee",
    expression_1406: "Política de privacidade",

    expression_1407: "Selecione uma tag para adicionar",
    expression_1408: "Atualizar",
    expression_1409: "Ver menos",
    expression_1410: "Campos Personalizados",
    expression_1411: "Nenhum campo personalizado disponível",
    expression_1412: "Digite o valor para",
    expression_1413: "Oportunidade",
    expression_1414: "Valor",
    expression_1415: "Selecione um canal primeiro",
    expression_1416: "Selecione um canal para ver os campos personalizados",
    expression_1417: "Não há campos personalizados disponíveis para este canal",
    expression_1418: "Adicionar Campo",
    expression_1419: "Todos os campos",
    expression_1420: "Campos Selecionados",
    expression_1421: "Nenhum campo selecionado",
    expression_1422: "Filtros Gerais",
    expression_1423: "Campo atualizado",
    expression_1424: "Erro ao atualizar campo:",
    expression_1425: "Erro ao salvar campo",
    expression_1426: "Falha na atualização do valor",
    expression_1427: "Falha ao carregar campos personalizados",
    expression_1428: "Falha ao atualizar o e-mail",
    expression_1429: "E-mail atualizado!",
    expression_1430: "Nome atualizado!",
    expression_1431: "Não foi possível atualizar o nome",
    expression_1432: "Newsletter atualizada!",
    expression_1433: "Não foi possível atualizar a inscrição",
    expression_1434:"Nenhuma oportunidade encontrada",
    expression_1435: "Buscando leads...",
    expression_1436: "Nenhum lead encontrado com os filtros atuais.",
    expression_1437: "Confirmo que obtivemos o consentimento adequado para enviar SMS, e-mail ou outros tipos de mensagens aos contatos que estão sendo criados ou importados, em conformidade com as leis e regulamentos aplicáveis.",
    expression_1438: "Você precisa aceitar os termos para continuar.",
    expression_1439: 'Nome do Campo',
expression_1440: 'Tipo de Campo',
expression_1441: 'Novo Campo',
expression_1442: 'Ações',
expression_1443: 'Ativos',
expression_1444: 'Arquivados',
expression_1445: 'Selecione o Canal',
expression_1446: 'Selecione um canal para visualizar os campos personalizados',
expression_1447: 'Confirma a exclusão do atributo e informações dele?',
expression_1448: 'Esta ação não pode ser desfeita e todos os dados associados serão perdidos.',
expression_1449: 'Excluir o atributo',
expression_1450: 'Gerencie suas preferências e personalizações',
expression_1451: 'Editar Campo',
expression_1452: 'Campo criado com sucesso',
expression_1453: 'Campo atualizado com sucesso',
expression_1454: 'Opções',

expression_1455: 'Adicionar Opção',
expression_1456: 'Criar Campo',
expression_1457: 'Nenhum campo encontrado para',
expression_1458: 'Nenhum campo personalizado criado para este canal',
expression_1459: 'Criar Primeiro Campo',
expression_1460: 'Nome do campo',
expression_1461: 'Campo arquivado com sucesso',
expression_1462: 'Campo desarquivado com sucesso',
expression_1463: 'Já existe um campo com este nome',
expression_1464: 'Adicione pelo menos uma opção para o campo de seleção',
expression_1465: 'O nome do campo é obrigatório',
expression_1466: 'O nome do campo deve ter no máximo 30 caracteres',
expression_1467: 'Selecione um canal antes de salvar o campo',
expression_1468: 'Campo',
expression_1469: 'excluído com sucesso',
expression_1470: 'Limpar tudo',
expression_1471: 'Últimas negociações',
expression_1472: 'Orçamento',
expression_1473: "Protocolo copiado:",
expression_1474: "Copiado!",
expression_1475: "Agenda",
  // expression_1476: "Olá! Sua sessão de conversa no WhatsApp foi encerrada. Para iniciar uma nova conversa, selecione um modelo de mensagem clicando",
  // expression_1477: "aqui",
  expression_1478: "Nova Oportunidade",
  expression_1479: "Nova Proposta",
  expression_1480: "Nenhuma compra registrada",
  expression_1481: "Buscar",
  expression_1482: "Digite algo para buscar contatos",
  expression_1483: "Use o campo de busca acima.",
expression_1484: "Nenhum contato encontrado",
expression_1485: "Tente usar termos diferentes ou verifique se o contato está cadastrado no sistema.",
expression_1486: "Inscrito",
expression_1487: "Cancelar inscrição",
expression_1488: "Não inscrito",
expression_1489: "(Inscrever-se)",
expression_1490: "Conversas e atendimentos",
expression_1491: "Templates HSM",
expression_1492: "Mídia",
expression_1493: "Esconder detalhes do lead",
expression_1494: "Mostrar detalhes do lead",
expression_1495: "Carregando as mensagens. Por favor, aguarde.",
expression_1496: "Selecionar canal",
expression_1497: "Escolha as tags para segmentar sua audiência",
expression_1498: "Selecione as tags...",
expression_1499: "Selecionar Mensagem Modelo",  
expression_1500: "Escolher mensagem modelo",   
expression_1501: "Todas",      
expression_1502: "Limpar",   
expression_1503: "de",  
expression_1504: "selecionadas",   
expression_1505: "Preencha a informação personalizada",  
expression_1506: "Variáveis do Sistema",
expression_1507: "Clique em uma variável para inserir no texto",
expression_1508: "Opções de envio", 
expression_1509: "Selecione um template acima.",  
expression_1510: "Escolha um ficheiro PDF",
expression_1511: "Escolha um ficheiro JPG ou PNG",
expression_1512: "Mensagem modelo",
expression_1513: "Hora",
expression_1514: "Horas recomendadas",
expression_1515: "As publicações só podem ser partilhadas entre 20 minutos e 29 dias depois de criadas.",
expression_1516: "Melhores horários para engajamento",
expression_1517: "Baseado em estudos de comportamento do usuário",
expression_1518: "Nenhum modelo encontrado para",
expression_1519: "Tente usar termos diferentes ou verifique a ortografia.",
expression_1520: "Buscando modelo",  
    divisor: '__________________________________________________________________________________________',
    tags: 'Tags',
    departments: 'Departamentos',
    histories: 'Mensagens (API)',
    interests: 'Interesses',
    motives: 'Qualificação do Protocolo',
    operators: 'Operadores',
    replies: 'Respostas Rápidas',
    sources: '',
    users: 'Acessos',
    widget: 'Widget',
    chats: "Conversas",
  },
  getters: {
    getTranslationPtBr: () => (key) => {
      return key.pt_br
    },
  },
}
export default pt_br;
